import { gql } from "@apollo/client";

export const GET_EVENTS = gql`
  query GetEvents {
    events {
      id
      title
      eventType
      date
      location
      description
      heroImageUrl
      galleryImageUrls
    }
  }
`;

export const GET_EVENT = gql`
  query GetEvent($id: ID!) {
    event(id: $id) {
      id
      title
      eventType
      date
      location
      description
      heroImageUrl
      galleryImageUrls
    }
  }
`;

export const GET_SERVICES = gql`
  query GetServices {
    services {
      id
      name
      description
      priceRange
      imageUrl
    }
  }
`;

export const GET_TESTIMONIALS = gql`
  query GetTestimonials {
    testimonials {
      id
      clientName
      quote
      eventType
      rating
    }
  }
`;
